import { LatamHomePage } from '@/screens/Latam/Home/LatamHomePage';

export default function OpendockPage() {
  return <LatamHomePage locale="es-MX" />;
}
